import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../store';
import { authService } from '../services/authService';
import { logout } from '../store/slices/authSlice';

export const ProfilePage: React.FC = () => {
  const currentUser = useSelector((state: RootState) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    await authService.logout();
    dispatch(logout());
    navigate('/');
  };

  if (!currentUser) return null;

  return (
    <div className="page-container">
      <div className="page-header" style={{ marginBottom: '1.5rem' }}>
        <div className="header-row" style={{ justifyContent: 'flex-start', gap: '1rem' }}>
          <button onClick={() => navigate(-1)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem', background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--text-dark)' }}>
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </button>
          <h1 className="page-title" style={{ margin: 0, lineHeight: 1 }}>My Profile</h1>
        </div>
      </div>

      <div className="vendor-info-card" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        <div>
          <p className="info-label">Name</p>
          <p className="info-value">{currentUser.first_name} {currentUser.last_name}</p>
        </div>
        <div>
          <p className="info-label">Email</p>
          <p className="info-value">{currentUser.email}</p>
        </div>
        <div>
          <p className="info-label">Username</p>
          <p className="info-value">{currentUser.username}</p>
        </div>
        <div>
          <p className="info-label">Role</p>
          <p className="info-value"><span className="status-badge status-active">{currentUser.role}</span></p>
        </div>
        <div>
          <p className="info-label">Department</p>
          <p className="info-value">{currentUser.department}</p>
        </div>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <button className="danger-btn" onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="18" height="18">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Logout
        </button>
      </div>
    </div>
  );
};
